import React from 'react';
import styled from 'styled-components';
import TimelineTimelineYearsDecade from './TimelineTimelineYearsDecade';
import { detectEnter, detectEscape, setDecadeOnEscape } from './Timeline._helpers';
const Container = styled.div `
  width: 100%;
`;
const ContainerYears = styled.div ``;
const TimelineTimelineDesktop = ({ years, setDecade, setLang, setYear, setId, handleClick, handleClickDecade }) => {
    const handleKeyboardLocal = (evt, decade) => {
        if (detectEnter(evt)) {
            handleClickDecade(decade);
        }
        else if (detectEscape(evt)) {
            setDecadeOnEscape();
        }
    };
    return (React.createElement(Container, null, years.map((yearSet, idx) => {
        return (React.createElement(ContainerYears, { key: `ds${idx}`, onKeyDown: evt => handleKeyboardLocal(evt, yearSet.decade) },
            React.createElement(TimelineTimelineYearsDecade, { handleClick: handleClick, handleClickDecade: handleClickDecade, key: `d${yearSet.decade}`, decade: yearSet.decade, years: yearSet.items, setDecade: setDecade, setLang: setLang, setYear: setYear, setId: setId })));
    })));
};
export default TimelineTimelineDesktop;
